// Environment configuration for AES encryption
// This should match your backend .env settings

export const AES_CONFIG = {
  // This should match your backend APP_AES_IV

  // In production, consider using environment variables:
  IV: process.env.REACT_APP_AES_IV || "1234567890123456",
};

// Helper function to get AES secret (MD5 hash of IV)
export const getAESSecret = (): string => {
  const CryptoJS = require("crypto-js");
  return CryptoJS.MD5(AES_CONFIG.IV).toString();
};
